import React, { useState, useEffect, useMemo } from "react";
import {
    Button,
    Form,
    Input,
    Modal,
    Typography,
    Space,
    Tooltip,
    Alert,
    message,
    DatePicker,
    Segmented,
    theme,
    Grid,
} from "antd";
import {
    FacebookFilled,
    TwitterOutlined,
    InstagramFilled,
    LinkedinFilled,
    YoutubeOutlined,
    CheckCircleFilled,
    EyeOutlined,
    ShoppingCartOutlined,
    UserAddOutlined,
    HeartOutlined,
    ArrowUpOutlined,
    DoubleLeftOutlined,
    DoubleRightOutlined,
} from "@ant-design/icons";
import { HiOutlineSpeakerphone } from "react-icons/hi";
import { GoPeople, GoTag } from "react-icons/go";
import { LuMousePointerClick } from "react-icons/lu";
import BusinessFormModal from "../business_form/BusinessFormWrapper";
import { useUpdateItemMutation } from "../_actions/app/items";
import { useBusiness } from "../_actions/finance";
import { useCurrentUser } from "../actions/auth";
import { useItemsFine } from "../_actions/app/items";
import { useTokens } from "../_actions/finance";
import styles from "./styles/ContentCalenderForm.module.css";
import { queryClient } from "../_helpers/query";
import { useCalendarOutline } from "../_actions/bot";
import CalendarOutlineGenerator from "./CalendarOutline";
import dayjs from "dayjs";
// Add imports for pie chart
import { Pie } from "@ant-design/plots";
import { platform } from "@floating-ui/dom";
import log from "cslog";
import TokenManagerModal from "../finance/TokenManagerModal";
import TokenInButton from "../finance/TokenInButton";
import SocialDateRangePicker from "./SocialDateRangePicker";
import {
    COST_CALENDAR_GENERATION,
    COST_CALENDAR_OUTLINE_MULTIPLIER,
} from "../constants";
import { ContentThemePicker } from "./NewAddPanel";
import QLottie from "../show/components/QLottie";
import ideaLoadingAnimation from "../media/animations/idea_loading.json";

const { Title, Text } = Typography;
const { TextArea } = Input;

const PLATFORM_FREQUENCY_MAPPING = {
    facebook: [1, "d"],
    instagram: [2, "d"],
    x: [1, "d"],
    youtube: [3, "w"],
    linkedin: [6, "w"],
    medium: [3, "w"],
    blog: [2, "w"],
    threads: [1, "d"],
};

export default function ContentCalenderForm({ trigger, me }) {
    const { token } = theme.useToken();
    const { useBreakpoint } = Grid;
    const screens = useBreakpoint();
    const isMobile = !screens.sm;
    const [open, setOpen] = useState(false);
    const [form] = Form.useForm();
    const [selectedSocials, setSelectedSocials] = useState([
        "instagram",
        "facebook",
        "linkedin",
    ]);
    const [goalOrStrategy, setGoalOrStrategy] = useState("strategy");
    const [selectedGoal, setSelectedGoal] = useState(null);
    const [selectedStrategy, setSelectedStrategy] = useState(null);
    const [contentTheme, setContentTheme] = useState("general");

    const [newSelectedStrategy, setNewSelectedStrategy] = useState(null);

    const [submitting, setSubmitting] = useState(false);
    // const [dateRange, setDateRange] = useState([null, null]);
    const today = dayjs();
    const sevenDaysLater = today.add(6, "days");
    const [dateRange, setDateRange] = useState([today, sevenDaysLater]);
    const [dateOption, setDateOption] = useState("1 Week");
    const [outlineResult, setOutlineResult] = useState(null);
    const [outlineOpen, setOutlineOpen] = useState(false);
    const [openTokenModal, setOpenTokenModal] = useState(false);

    const {
        isLoading: loadingStrategies,
        isSuccess: successStrategies,
        data: dataStrategies,
    } = useItemsFine("qdb_content_strategies", "", true, false);
    console.log("cal strategies are ", dataStrategies);
    const [isStrategyShowMore, setIsStrategyShowMore] = useState(false);

    const [payload, setPayload] = useState(null);

    const { data: tokenData } = useTokens(me.selected_org?.id);
    const businessData = {
        USP: me.selected_org?.USP,
        brand_vibes: me.selected_org?.brand_vibes,
        business_modal: me.selected_org?.business_model,
        description: me.selected_org?.description,
        industry: me.selected_org?.industry,
    };
    // Check if any required fields are missing
    const missingFields = Object.entries(businessData)
        .filter(([key, value]) => !value || value.trim() === "")
        .map(([key]) => key);

    const businessDataComplete = missingFields.length === 0;

    console.log("businesdata", businessData);
    console.log("data in me", me);

    log.d(newSelectedStrategy, "newSelectedStrategy");

    const mutationOutline = useCalendarOutline((result) => {
        console.log(result, "outline generated");
        if (result?.success === true) {
            setOutlineResult(result?.data);
            setSubmitting(false);
            setOutlineOpen(true);
            setOpen(false);
        }
        if (
            result?.success === false &&
            result?.error?.code === "TOKEN_INSUFFICIENT"
        ) {
            setOpen(false);
            message.error(result?.error?.msg);
            setOpenTokenModal(true);
        }
    });

    const outlineSubmit = (values) => {
        console.log("Form values:", values); // Add this line
        console.log("dateRange", values?.dateRange);
        console.log("Date option:", dateOption); // Add this line
        console.log("Content theme:", contentTheme); // Add this line

        if (!businessDataComplete) {
            message.error(
                "Business data not found. Please set up your business profile first."
            );
            return;
        }
        setSubmitting(true);

        // const [start_dt, end_dt] = values.dateRange || [null, null];
        const [start_dt, end_dt] = dateRange || [null, null];

        log.d([start_dt, end_dt], "date range");

        let payload;

        // return;

        if (dateOption === "1 day") {
            // For 1 day, only send start_dt, end_dt, platforms, and contentTheme
            payload = {
                platforms: selectedSocials?.map((social) => {
                    return [social, ...PLATFORM_FREQUENCY_MAPPING[social]];
                }),
                start_dt: start_dt ? start_dt.format("YYYY-MM-DD") : undefined,
                end_dt: end_dt ? end_dt.format("YYYY-MM-DD") : undefined,
                content_theme: contentTheme,
            };
        } else {
            // For other date options, include goal or strategy
            payload = {
                platforms: selectedSocials?.map((social) => {
                    return [social, ...PLATFORM_FREQUENCY_MAPPING[social]];
                }),
                start_dt: start_dt ? start_dt.format("YYYY-MM-DD") : undefined,
                end_dt: end_dt ? end_dt.format("YYYY-MM-DD") : undefined,
            };

            if (goalOrStrategy === "goal") {
                payload.main_goal = selectedGoal;
            } else {
                payload.chosen_strategy = newSelectedStrategy?.id;
            }
        }

        setPayload(payload);
        mutationOutline.mutate(payload);
    };

    const handleSocialSelect = (socialType) => {
        if (selectedSocials.includes(socialType)) {
            setSelectedSocials(
                selectedSocials.filter((type) => type !== socialType)
            );
        } else {
            setSelectedSocials([...selectedSocials, socialType]);
        }

        // Update form value
        form.setFieldsValue({ socialPlatforms: selectedSocials });
    };

    const handleGoalSelect = (goalId) => {
        setSelectedGoal(goalId);
        form.setFieldsValue({ main_goal: goalId });
    };

    useEffect(() => {
        // Set initial form values when component mounts
        if (dataStrategies) {
            // Find 50-30-20 strategy by default
            const defaultStrategy = dataStrategies.find(
                (strategy) => strategy.id === "50_30_20_rule"
            );
            if (defaultStrategy) {
                setNewSelectedStrategy(defaultStrategy);
                setGoalOrStrategy("strategy");
            }
            form.setFieldsValue({
                // dateRange: [today, sevenDaysLater],
                socialPlatforms: selectedSocials,
                main_goal: defaultStrategy,
            });
        }
    }, [dataStrategies, form, selectedSocials]);

    // Define social media platforms with their icons
    const socialMediaPlatforms = [
        // {
        //     name: "facebook",
        //     icon: (
        //         <img
        //             src="/images_rte/icons/facebook.png"
        //             alt="Facebook"
        //             className={styles.socialIconImg}
        //         />
        //     ),
        // },
        {
            name: "instagram",
            icon: (
                <img
                    src="/images_rte/icons/instagram.png"
                    alt="Instagram"
                    className={styles.socialIconImg}
                />
            ),
        },
        // {
        //     name: "threads",
        //     icon: (
        //         <img
        //             src="/images_rte/icons/threads.png"
        //             alt="Thread"
        //             className={styles.socialIconImg}
        //         />
        //     ),
        // },
        {
            name: "linkedin",
            icon: (
                <img
                    src="/images_rte/icons/linkedin.png"
                    alt="Linkedin"
                    className={styles.socialIconImg}
                />
            ),
        },
        {
            name: "x",
            icon: (
                <img
                    src="/images_rte/icons/twitter.png"
                    alt="Twitter"
                    className={styles.socialIconImg}
                />
            ),
        },
        {
            name: "medium",
            icon: (
                <img
                    src="/images_rte/icons/medium.png"
                    alt="medium"
                    className={styles.socialIconImg}
                />
            ),
        },
        // {
        //     name: "pinterest",
        //     icon: (
        //         <img
        //             src="/images_rte/icons/pinterest.png"
        //             alt="Pinterest"
        //             className={styles.socialIconImg}
        //         />
        //     ),
        // },
    ];

    // Define marketing goals
    const marketingGoals = [
        {
            id: "increase_brand_awareness",
            icon: <HiOutlineSpeakerphone />,
            title: "Brand Awareness",
            description: "Increase visibility and recognition of your brand",
        },
        {
            id: "website_traffic",
            icon: <LuMousePointerClick />,
            title: "Website Traffic",
            description: "Collect contact information from potential customers",
        },
        {
            id: "lead_generation",
            icon: <GoPeople />,
            title: "Lead Generation",
            description: "Drive purchases and increase revenue directly",
        },
        {
            id: "sales_boost",
            icon: <GoTag />,
            title: "Sales Boost",
            description: "Keep existing customers engaged and loyal",
        },
    ];

    // const colors = ["#0088FE", "#00C49F", "#f88a54ff", "#8884D8"];

    return (
        <>
            <div onClick={() => setOpen(true)}>{trigger}</div>
            <Modal
                open={open}
                style={{ top: isMobile ? 0 : 20 }}
                onCancel={() => setOpen(false)}
                width={isMobile ? "100%" : 1200}
                styles={
                    isMobile
                        ? {
                              container: isMobile
                                  ? {
                                        padding: "16px",
                                    }
                                  : {},
                              content: { borderRadius: 0, minHeight: "100svh" },
                              body: isMobile
                                  ? {
                                        padding: 0,
                                    }
                                  : {
                                        maxHeight: "calc(100svh - 55px)",
                                        overflowY: "auto",
                                        padding: "16px 16px 0",
                                    },
                          }
                        : undefined
                }
                footer={[
                    businessDataComplete ? (
                        <Button
                            key="back"
                            type="primary"
                            onClick={form.submit}
                            loading={mutationOutline.isLoading}
                            disabled={mutationOutline.isLoading}
                            size={isMobile ? "large" : "middle"}
                            block={isMobile}
                        >
                            {mutationOutline.isLoading
                                ? "Generating..."
                                : "Generate Your Plan"}
                            <TokenInButton
                                count={
                                    (DAY_MAPPING?.[dateOption] || 0) *
                                    COST_CALENDAR_OUTLINE_MULTIPLIER
                                }
                            />
                        </Button>
                    ) : null,
                ]}
            >
                <div style={{ position: "relative" }}>
                    <div style={{ marginBottom: isMobile ? 20 : 45 }}>
                        <Title
                            level={isMobile ? 4 : 3}
                            className={styles.title}
                        >
                            Let's Customize Your Content Plan
                        </Title>
                        <div className={styles.subtitle}>
                            Personalize your content plan in minutes based on
                            your platforms, goals, and audience.
                        </div>
                    </div>
                    {/* <pre>{JSON.stringify(selectedSocials, null, 2)}</pre> */}
                    <Form
                        form={form}
                        layout="vertical"
                        // onFinish={handleSubmit}
                        onFinish={outlineSubmit}
                    >
                        {!businessDataComplete && (
                            <>
                                <Alert
                                    message="Business Profile Required"
                                    description="You need to set up your business profile before creating a content plan."
                                    type="info"
                                    showIcon
                                    style={{ marginBottom: 20 }}
                                />
                                <BusinessFormModal
                                    trigger={
                                        <Button
                                            key="setupBusiness"
                                            type="primary"
                                        >
                                            Set Up Your Business Profile First
                                        </Button>
                                    }
                                />
                            </>
                        )}
                        <SocialDateRangePicker
                            dateOption={dateOption}
                            setDateOption={setDateOption}
                            dateRange={dateRange}
                            setDateRange={setDateRange}
                            form={form}
                        />
                        <Form.Item name="platforms" labelCol={{ span: 24 }}>
                            <div className={styles.group}>
                                <span
                                    className={styles.label}
                                    style={{ flexShrink: 0 }}
                                >
                                    Select social platforms
                                </span>
                                {/* <button className={styles.button}>
                                Connect your Socials
                            </button> */}
                            </div>
                            {/* <span style={{ color: "rgb(134, 132, 132)" }}>
                            Choose where you actively post content so we can
                            tailor the plan for each platform.
                        </span> */}
                            <div className={styles.socialGroup}>
                                <div className={styles.socialIconsGrid}>
                                    {socialMediaPlatforms.map((platform) => (
                                        <Tooltip
                                            key={platform.name}
                                            title={
                                                platform.name
                                                    .charAt(0)
                                                    .toUpperCase() +
                                                platform.name.slice(1)
                                            }
                                        >
                                            <div
                                                onClick={() =>
                                                    handleSocialSelect(
                                                        platform.name
                                                    )
                                                }
                                                className={`${
                                                    styles.socialIcon
                                                } ${
                                                    selectedSocials.includes(
                                                        platform.name
                                                    )
                                                        ? styles.selected
                                                        : ""
                                                }`}
                                            >
                                                {platform.icon}
                                                {selectedSocials.includes(
                                                    platform.name
                                                ) && (
                                                    <CheckCircleFilled
                                                        className={
                                                            styles.checkmark
                                                        }
                                                    />
                                                )}
                                            </div>
                                        </Tooltip>
                                    ))}
                                </div>
                            </div>
                        </Form.Item>
                        {/* <p>Content theme: {contentTheme}</p> */}
                        {dateOption === "1 day" && (
                            <Form.Item
                                name="contentTheme"
                                label={
                                    <div className={styles.label}>
                                        Content Theme
                                    </div>
                                }
                            >
                                <ContentThemePicker
                                    value={contentTheme}
                                    onChange={(value) => {
                                        setContentTheme(value);
                                        form.setFieldsValue({
                                            contentTheme: value,
                                        });
                                    }}
                                />
                            </Form.Item>
                        )}
                        {dateOption !== "1 day" && (
                            <Form.Item
                                name="main_goal"
                                label={
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            alignItems: "center",
                                            gap: 16, // Adds a gap between heading and segmented
                                            marginBottom: 8,
                                        }}
                                    >
                                        <div className={styles.label}>
                                            Set your main marketing{" "}
                                            {goalOrStrategy}
                                        </div>
                                        {/* <Segmented
                                    options={[
                                        { label: "Goal", value: "goal" },
                                        {
                                            label: "Strategy",
                                            value: "strategy",
                                        },
                                    ]}
                                    value={goalOrStrategy}
                                    onChange={setGoalOrStrategy}
                                    style={{
                                        minWidth: 120,
                                        background: "#f5f5f5",
                                        borderRadius: 8,
                                        fontWeight: 500,
                                        marginTop: "10px",
                                    }}
                                /> */}
                                    </div>
                                }
                            >
                                <Segmented
                                    options={[
                                        { label: "By Goal", value: "goal" },
                                        {
                                            label: "Strategy",
                                            value: "strategy",
                                        },
                                    ]}
                                    value={goalOrStrategy}
                                    onChange={setGoalOrStrategy}
                                    style={{
                                        minWidth: 120,
                                        background: token.colorBgLayout,
                                        borderRadius: 8,
                                    }}
                                />
                                <div
                                    style={{
                                        color: token.colorTextTertiary,
                                        paddingTop: "10px",
                                    }}
                                >
                                    {goalOrStrategy === "goal"
                                        ? "Choose your main objective so we can align your content strategy with the right goals."
                                        : `Choose your main strategy to guide your content plan.
                                (Recommended Strategy is already chosen based on your business information)`}
                                </div>

                                {/* Updated layout to include pie chart on the right */}
                                <div
                                    style={{
                                        display: "flex",
                                        gap: "20px",
                                        flexDirection: isMobile
                                            ? "column"
                                            : "row",
                                    }}
                                >
                                    <div style={{ flex: 1 }}>
                                        <div
                                            className={
                                                styles.goalCardsContainer
                                            }
                                        >
                                            {goalOrStrategy === "strategy" &&
                                                successStrategies &&
                                                dataStrategies?.length > 0 &&
                                                dataStrategies
                                                    .slice(
                                                        0,
                                                        isStrategyShowMore
                                                            ? dataStrategies.length
                                                            : 8
                                                    )
                                                    .map((item) => (
                                                        <StrategyCard
                                                            item={item}
                                                            isSelected={
                                                                newSelectedStrategy?.id ===
                                                                item.id
                                                            }
                                                            onClick={() => {
                                                                setNewSelectedStrategy(
                                                                    item
                                                                );
                                                            }}
                                                        />
                                                    ))}

                                            {(goalOrStrategy === "goal"
                                                ? marketingGoals
                                                : // : marketingStrategies
                                                  []
                                            ).map((item) => (
                                                <div
                                                    key={item.id}
                                                    className={`${
                                                        styles.goalCard
                                                    } ${
                                                        (
                                                            goalOrStrategy ===
                                                            "goal"
                                                                ? selectedGoal ===
                                                                  item.id
                                                                : selectedStrategy ===
                                                                  item.id
                                                        )
                                                            ? styles.selectedGoal
                                                            : ""
                                                    }`}
                                                    onClick={() => {
                                                        if (
                                                            goalOrStrategy ===
                                                            "goal"
                                                        ) {
                                                            setSelectedGoal(
                                                                item.id
                                                            );
                                                            form.setFieldsValue(
                                                                {
                                                                    main_goal:
                                                                        item.id,
                                                                }
                                                            );
                                                        } else {
                                                            setSelectedStrategy(
                                                                item.id
                                                            );
                                                            form.setFieldsValue(
                                                                {
                                                                    main_goal:
                                                                        item.id,
                                                                }
                                                            );
                                                        }
                                                    }}
                                                >
                                                    <div
                                                        className={
                                                            styles.goalHeaderContainer
                                                        }
                                                    >
                                                        <div
                                                            className={
                                                                styles.goalIconContainer
                                                            }
                                                        >
                                                            {item.icon}
                                                        </div>
                                                        <h3
                                                            className={
                                                                styles.goalTitle
                                                            }
                                                        >
                                                            {item.title}
                                                        </h3>
                                                    </div>
                                                    <p
                                                        className={
                                                            styles.goalDescription
                                                        }
                                                    >
                                                        {item.description}
                                                    </p>

                                                    {(goalOrStrategy === "goal"
                                                        ? selectedGoal ===
                                                          item.id
                                                        : selectedStrategy ===
                                                          item.id) && (
                                                        <div
                                                            className={
                                                                styles.goalCheckmark
                                                            }
                                                        >
                                                            <CheckCircleFilled />
                                                        </div>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                        {goalOrStrategy === "strategy" && (
                                            <div
                                                style={{
                                                    width: "100%",
                                                    textAlign: "center",
                                                    marginTop: "10px",
                                                }}
                                            >
                                                {isStrategyShowMore ? (
                                                    <Button
                                                        type="link"
                                                        icon={
                                                            <DoubleLeftOutlined
                                                                rotate={90}
                                                            />
                                                        }
                                                        iconPosition="end"
                                                        onClick={() =>
                                                            setIsStrategyShowMore(
                                                                false
                                                            )
                                                        }
                                                    >
                                                        Show Less
                                                    </Button>
                                                ) : (
                                                    <Button
                                                        type="link"
                                                        icon={
                                                            <DoubleLeftOutlined
                                                                rotate={270}
                                                            />
                                                        }
                                                        iconPosition="end"
                                                        onClick={() =>
                                                            setIsStrategyShowMore(
                                                                true
                                                            )
                                                        }
                                                    >
                                                        Show More
                                                    </Button>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                    <div
                                        style={{
                                            width: isMobile ? "100%" : "200px",
                                            display: "flex",
                                            justifyContent: isMobile
                                                ? "center"
                                                : undefined,
                                        }}
                                    >
                                        {goalOrStrategy === "strategy" &&
                                            newSelectedStrategy && (
                                                <StrategyPie
                                                    data={newSelectedStrategy}
                                                    isMobile={isMobile}
                                                />
                                            )}
                                    </div>
                                    {/* {goalOrStrategy === "strategy" &&
                                selectedStrategy &&
                                pieData.length > 0 && (
                                    <div
                                        style={{
                                            display: "flex",

                                            alignItems: "center",
                                        }}
                                    >
                                        <Pie
                                            {...{
                                                data: pieData,
                                                angleField: "value",
                                                colorField: "name",
                                                colors: colors,
                                                label: {
                                                    text: "value",
                                                    style: {
                                                        fontWeight: "bold",
                                                    },
                                                },
                                                legend: false,
                                                height: 130,
                                                width: 130,
                                            }}
                                        />
                                        <div>
                                            <ul
                                                style={{
                                                    listStyleType: "none",
                                                    padding: 0,
                                                }}
                                            >
                                                {pieData.map((item, index) => (
                                                    <li
                                                        key={index}
                                                        style={{
                                                            marginBottom: "8px",
                                                        }}
                                                    >
                                                        <span
                                                            style={{
                                                                display:
                                                                    "inline-block",
                                                                marginRight:
                                                                    "8px",
                                                                height: "10px",
                                                                width: "10px",
                                                                backgroundColor:
                                                                    colors[
                                                                        index %
                                                                            colors.length
                                                                    ], // Match pie chart colors
                                                            }}
                                                        ></span>
                                                        <span>{item.name}</span>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                )} */}
                                </div>
                            </Form.Item>
                        )}

                        {/* {newSelectedStrategy && (
                        <pre>
                            {JSON.stringify(newSelectedStrategy, null, 2)}
                        </pre>
                    )} */}

                        {/* <Form.Item
                        name="custom_instructions"
                        label={
                            <div className={styles.label}>
                                Any upcoming events or special offers?
                            </div>
                        }
                    >
                        <TextArea
                            rows={4}
                            placeholder="e.g., Diwali Sale from 1st–10th Nov, Women’s Day Giveaway, New Product Launch on June 25"
                        />
                    </Form.Item> */}
                    </Form>
                    {mutationOutline.isLoading && (
                        <div
                            style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                backgroundColor: `${token.colorBgContainer}CC`,
                                zIndex: 10,
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                borderRadius: "8px",
                                backdropFilter: "blur(2px)",
                            }}
                        >
                            <QLottie
                                animation={ideaLoadingAnimation}
                                styles={{ width: 300, height: 300 }}
                            />
                            <Title level={4} style={{ marginTop: 20 }}>
                                Generating Your Plan...
                            </Title>
                        </div>
                    )}
                </div>
            </Modal>
            <CalendarOutlineGenerator
                open={outlineOpen}
                setOpen={setOutlineOpen}
                data={outlineResult}
                user_inputs={payload}
            />
            <TokenManagerModal
                selected_org={me?.selected_org?.id}
                open={openTokenModal}
                onClose={() => setOpenTokenModal(false)}
            />
        </>
    );
}

function StrategyCard({ item, isSelected, onClick }) {
    const { token } = theme.useToken();
    return (
        <div
            key={item.id}
            className={styles.goalCard}
            style={{
                border: isSelected
                    ? `2px solid ${token.colorPrimary}`
                    : `1px solid ${token.colorBorder}`,
                backgroundColor: token.colorBgContainer,
                boxShadow: isSelected
                    ? `0 4px 12px ${token.colorPrimary}26`
                    : undefined,
            }}
            onClick={onClick}
        >
            <div className={styles.goalHeaderContainer}>
                {item.icon && (
                    <div className={styles.goalIconContainer}>{item.icon}</div>
                )}
                <h3 className={styles.goalTitle}>{item.display_name}</h3>
            </div>
            <p
                className={styles.goalDescription}
                style={{ color: token.colorTextTertiary }}
            >
                {item.subtitle}
            </p>

            {isSelected && (
                <div
                    className={styles.goalCheckmark}
                    style={{ color: token.colorPrimary }}
                >
                    <CheckCircleFilled />
                </div>
            )}
        </div>
    );
}

function StrategyPie({ data, isMobile }) {
    return (
        <div
            style={{
                display: "flex",
                flexDirection: isMobile ? "row" : "column",
                alignItems: "center",
            }}
        >
            <div>
                <Pie
                    {...{
                        data: data.composition?.map((item) => {
                            return {
                                type: item.name,
                                value: item.value,
                            };
                        }),
                        angleField: "value",
                        colorField: "type",
                        colors: data.composition?.map((item) => item.color),
                        // color: ["#7ccc92", "#87c6ed", "#ed87d0"],
                        label: {
                            text: "value",
                            style: {
                                fontWeight: "bold",
                            },
                        },
                        legend: false,
                        height: 160,
                        width: 160,
                    }}
                />
            </div>
            <div>
                <ul
                    style={{
                        listStyleType: "none",
                        padding: 0,
                    }}
                >
                    {data.composition.map((item, index) => (
                        <li
                            key={index}
                            style={{
                                marginBottom: "8px",
                            }}
                        >
                            <span
                                style={{
                                    display: "inline-block",
                                    marginRight: "8px",
                                    height: "10px",
                                    width: "10px",
                                    backgroundColor: item.color,
                                    // backgroundColor:colors[index % colors.length], // Match pie chart colors
                                }}
                            ></span>
                            <span>
                                {item.name} - {item.value}%
                            </span>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}

const DAY_MAPPING = {
    "1 day": 1,
    "3 days": 3,
    "5 days": 5,
    "1 Week": 7,
    "2 Weeks": 14,
    "1 Month": 30,
    Custom: 0,
};
